import {
  WSElement,
  WSFlexBox,
  WSIcon,
  WSText
} from "@wingspanhq/fe-component-library";
import { getShortDiffFromNow } from "../../../../utils/dates";
import { BulkReviewRow } from "../../types";
import styles from "./index.module.scss";

export const Row: React.FC<BulkReviewRow<any>> = props => {
  return (
    <WSElement className={styles.row}>
      <WSElement>
        <WSText.ParagraphSm color="gray600">{props.text}</WSText.ParagraphSm>

        {props.secondaryText && (
          <WSFlexBox alignItems="center" gap="XS">
            {props.secondaryTextIcon && (
              <WSIcon color="gray500" size="S" name={props.secondaryTextIcon} />
            )}

            <WSText.ParagraphXs color="gray500">
              {props.secondaryText}
            </WSText.ParagraphXs>
          </WSFlexBox>
        )}

        {props.tertiaryText && (
          <WSFlexBox alignItems="center" gap="XS">
            {props.tertiaryTextIcon && (
              <WSIcon color="gray500" size="S" name={props.tertiaryTextIcon} />
            )}

            <WSText.ParagraphXs color="gray500">
              {props.tertiaryText}
            </WSText.ParagraphXs>
          </WSFlexBox>
        )}
      </WSElement>

      {props.updatedAt && (
        <WSText.ParagraphXs color="gray500">
          {getShortDiffFromNow(props.updatedAt, false)}
        </WSText.ParagraphXs>
      )}
    </WSElement>
  );
};
